export default __webpack_public_path__ + "static/media/error404.add2c064.svg";